import { Currency } from "@lookiero/sty-psp-locale";

enum Type {
  DISCOUNT = "DISCOUNT",
  CHARGE = "CHARGE",
}

enum Context {
  PS_FEE = "PS_FEE",
  PROMOCODE = "PROMOCODE",
  BALANCE = "BALANCE",
}

interface Modifier {
  readonly amount: number;
  readonly percentage?: number;
  readonly type: Type;
  readonly context: Context;
  readonly translationKey: string;
}

interface CheckoutPricingProjection {
  readonly currency: Currency;
  readonly finalPrice: number; // total a pagar
  readonly originalPrice: number; // precio original de la caja
  readonly modifiers: Modifier[];
}

export type { CheckoutPricingProjection };
export { Type as CheckoutPricingType, Context as CheckoutPricingContext };
